export const SLIDER_CLOSE_ANIMATION_DURATION = 700;
